import { SAVED_SECTIONS_CLEAR_STATE } from 'state/actionCreators/savedSections';

export const clearSavedSectionsState = () => (dispatch) =>
  dispatch(SAVED_SECTIONS_CLEAR_STATE());
  